import { getAccessToken } from "../helpers/AccessToken";
import { API_BASE_URL } from "../config";
import fetchWithAuth from "../middlewares/fetchWithAuth";
const API_URL = `${API_BASE_URL}/equipoEstadisticas`;

export const getEstadisticasEquipoByIdEquipo = async (idEquipo, idTemporada, navigate) => {
  const params = new URLSearchParams({ idEquipo, idTemporada });
  const response = await fetchWithAuth(`${API_URL}?${params}`, { method: "GET" }, navigate);
  if (!response.ok) throw new Error("Error al obtener las estadísticas del equipo");
  return response.json();
};

export const getEstadisticasEquipoById = async (
  idTemporada,
  idEquipo,
  navigate
) => {
  try {
    const token = await getAccessToken(navigate);
    const response = await fetch(
      `${API_URL}?idTemporada=${idTemporada}&id=${idEquipo}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
      }
    );

    if (response.ok) {
      const data = await response.json();
      return data.length > 0 ? data[0] : null;
    } else {
      throw new Error("Error al obtener los datos");
    }
  } catch (error) {
    throw error;
  }
};

export const getEquiposByLetrasEquipo = async (letrasNombre, navigate) => {
  try {
    const token = await getAccessToken(navigate);
    const response = await fetch(
      `${API_URL}?letrasNombre=${encodeURIComponent(letrasNombre)}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
      }
    );

    if (response.ok) {
      const data = await response.json();
      return data; // Devuelve los datos de las temporadas
    } else {
      throw new Error("Error al obtener los datos");
    }
  } catch (error) {
    throw error;
  }
};
